"use client";

import useFollow from "@/shared/hooks/useFollow";
import useMe from "@/shared/hooks/useMe";
import { Button } from "../Button";
import { Type } from "../Button/constants";
import FollowIcon from "@/assets/icons/follow.svg";
import UnfollowIcon from "@/assets/icons/unfollow.svg";

const FollowingButton = ({ userId }: { userId: string }) => {
  const { me } = useMe();

  const isMeFollowing = !!me?.following?.some(
    (following) => following.folowee.id === userId,
  );
  const { isFollowing, toggleFollow } = useFollow({
    userId,
    isMeFollowing,
  });

  if (me?.id === userId) {
    return null;
  }
  return (
    <div className="w-full flex justify-start lg:justify-end ml-24 lg:ml-0">
      <Button
        element={Type.Button}
        startIcon={
          isFollowing ? (
            <UnfollowIcon className="w-6" />
          ) : (
            <FollowIcon className="w-6" />
          )
        }
        onClick={toggleFollow}
      >
        {isFollowing ? "Unfollow" : "Follow"}
      </Button>
    </div>
  );
};

export default FollowingButton;
